<template>
  <b-modal ref="modal" visible size="lg" :hide-footer="true" title="Productdetails" @hidden="$emit('close')">
    <div v-if="product.amount_sold_past_year > 25" class="alert alert-danger" role="alert">
      <p class="mb-0"><i class="fa fa-info-circle mr-5"></i> Hardloper</p>
    </div>
    <div v-if="product === null" class="text-center p-50">
      <i class="fa fa-spin fa-5x fa-spinner"></i>
    </div>
  
    <div v-else>
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Gegevens</h3>
        </div>
        <div class="block-content p-0">
          <table class="table">
            <tbody>
              <tr>
                <th scope="row">Naam</th>
                <td>{{ product.name }}</td>
              </tr>
              <tr>
                <th scope="row">SKU</th>
                <td>{{ product.sku }}</td>
              </tr>
              <tr v-if="product.parent_sku">
                <th scope="row">SKU Hoofdproduct</th>
                <td>{{ product.parent_sku }}</td>
              </tr>
              <tr>
                <th scope="row">GTIN</th>
                <td>{{ product.gtin }}</td>
              </tr>
              <tr>
                <th scope="row">Prijs</th>
                <td> <price-editable :price="product.price" :product-id="product.id" :key="product.id" ></price-editable> </td>
              </tr>
              <tr>
                <th scope="row">Sale prijs</th>
                <td> <sale-price-editable :price="product.price" :sale_price="product.sale_price" :product-id="product.id" :key="product.id" ></sale-price-editable> </td>
              </tr>
              <tr>
                <th scope="row">Inkoopprijs</th>
                <td> <purchase-price-editable :purchase-price="product.purchase_price" :product-id="product.id" :key="product.id"> </purchase-price-editable> </td>
              </tr>
              <tr>
                <th scope="row">Locatie</th>
                <td>
                  <location-editable field="location" :value="product.location" :product-id="product.id" :key="product.id"></location-editable>
                </td>
              </tr>
              <tr>
                <th scope="row">Locatie overvoorraad</th>
                <td>
                  <field-editable field="overstock_location" :value="product.overstock_location" :product-id="product.id" :key="product.id"></field-editable>
                </td>
              </tr>
              <tr>
                <th scope="row">Ligt in de winkel</th>
                <td>
                  <in-store-editable :in-store="!!product.in_store" :product-id="product.id" :key="product.id"></in-store-editable>
                </td>
              </tr>
              <tr>
                <th scope="row">Cadeaukoppeling</th>
                <td>
                  <externally-available-editable :externally-available="!!product.externally_available" :product-id="product.id" :key="product.id"></externally-available-editable>
                </td>
              </tr>
              <tr>
                <th scope="row">Voorraad</th>
                <td>
                  <stock-editable :quantity="product.stock_quantity" :product-id="product.id" :key="product.id"></stock-editable>
                </td>
              </tr>
              <tr>
                <th scope="row">Maat</th>
                <td>{{ product.size }}</td>
              </tr>
              <tr>
                <th scope="row">Gemaakt op</th>
                <td>{{ product.created_at | moment('calendar') }}</td>
              </tr>
              <tr>
                <th scope="row">Beschrijving</th>
                <td v-html="product.description" class="reset-font-size"></td>
              </tr>
              <tr>
                <th scope="row">Afbeelding(en)</th>
                <td><img class="img-thumbnail mr-10" width="100" v-for="imageUrl in product.image_urls" :key="imageUrl" :src="imageUrl" alt=""></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Voorraadmutaties</h3>
        </div>
        <div class="block-content p-0">
          <table class="table table-borderless table-striped table-hover">
            <thead>
              <tr>
                <th>Datum</th>
                <th>Mutatie</th>
                <th>Van</th>
                <th>Naar</th>
                <th>Oorzaak</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="mutation in product.stock_mutations" :key="mutation.id">
                <td>{{mutation.created_at | moment('DD-MM-YYYY HH:mm')}}</td>
                <td><span v-if="(mutation.new_quantity - mutation.old_quantity) > 0">+</span>{{mutation.new_quantity - mutation.old_quantity}}</td>
                <td>{{mutation.old_quantity}}</td>
                <td>{{mutation.new_quantity}}</td>
                <td>{{mutation.origin | origin}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <button @click="removeProduct" class="btn btn-outline-danger">
        <i class="fa fa-times mr-5"></i>
        Verwijder product
      </button>
    </div>
  </b-modal>
</template>

<script>
import StockEditable from './StockEditable'
import LocationEditable from './LocationEditable'
import FieldEditable from './FieldEditable'
import InStoreEditable from './InStoreEditable'
import SalePriceEditable from './SalePriceEditable.vue'
import PriceEditable from './PriceEditable.vue'
import PurchasePriceEditable from './PurchasePriceEditable'
import ExternallyAvailableEditable from './ExternallyAvailableEditable'

export default {
  components: { StockEditable, LocationEditable, FieldEditable, InStoreEditable, SalePriceEditable, PriceEditable, ExternallyAvailableEditable, PurchasePriceEditable },
  props: {
    productId: Number
  },
  data () {
    return {
      product: null
    }
  },
  methods: {
    loadProduct () {
      const params = {
        include: 'stockMutations'
      }
      this.$api.getProduct(this.productId, params)
        .then((result) => {
          this.product = result.data.data
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Dit product konden we niet vinden. Probeer het opnieuw.', 'warning')
          this.$refs.modal.hide()
        })
    },
    async removeProduct () {
      const yes = await this.$swal({
        title: 'Verwijderen?',
        text: 'Weet je zeker dat je dit product wilt verwijderen?',
        icon: 'error',
        buttons: {
          cancel: {
            text: 'Nee, terug',
            visible: true
          },
          confirm: {
            text: 'Ja, verwijderen',
            className: 'swal-button--danger'
          }
        }
      })

      if (yes) {
        this.$api.removeProduct(this.productId)
          .then((result) => {
            this.$swal('Verwijderd', 'Het product is succesvol verwijderd uit VM Control.', 'success')
            this.$emit('remove', this.productId)
            this.$refs.modal.hide()
          })
          .catch(() => {
            this.$swal('Ehmm...', 'Er is iets fout gegaan. Probeer het opnieuw.', 'warning')
          })
      }
    },
    show () {
      this.$refs.modal.show()
    }
  },
  filters: {
    origin (key) {
      const origins = {
        manual: 'Handmatig',
        order_placed: 'Bestelling geplaatst',
        order_canceled: 'Bestelling geannuleerd',
        society_of_lifestyle: 'Society of Lifestyle',
        present_time: 'Present Time',
        product_import: 'Productimport'
      }

      return origins[key] || 'Onbekend'
    }
  },
  created () {
    this.loadProduct()
  }
}
</script>

<style>
.reset-font-size * {
  font-size: inherit !important;
}
</style>



// WEBPACK FOOTER //
// ProductDetailModal.vue?317a86f0